import React, { useState, useEffect } from "react";
import { Typography, Box, Grid } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const fontSx = {
  fontSize: ["1rem", "1rem", "1rem", "1rem", "1.25rem", "1.25rem"],
};

const DeviceDetails = ({
  id,
  displayName,
  firmwareVersion,
  algVersion,
  wifiName,
  macAddress,
  hardwareId,
}) => {
  const [ethMac, setEthMac] = useState("");
  const [wifiMac, setWifiMac] = useState("");

  useEffect(() => {
    if (macAddress?.includes("||")) {
      const i = macAddress.indexOf("||");
      setEthMac(macAddress.substring(0, i));
      setWifiMac(macAddress.substring(i + 2));
    } else {
      setEthMac(macAddress);
      setWifiMac("");
    }
  }, [macAddress, setEthMac, setWifiMac]);

  return (
    <Box
      sx={{
        width: "100%",
        pl: "1rem",
        py: ["0rem", "5rem", "5rem", "5rem", "5rem", "5rem"],
      }}
    >
      <Grid container spacing={3} alignItems="center" justifyContent="center">
        <Grid size={12}>
          <Typography sx={fontSx} className={" text-gray-600 text-center"}>
            Device Info
          </Typography>
        </Grid>
        <Grid size={5}>
          <Typography sx={fontSx} className={" text-gray-600"}>
            Id:{" "}
          </Typography>
        </Grid>

        <Grid size={7}>
          <Typography sx={fontSx}>{id}</Typography>
        </Grid>
        <Grid size={5}>
          <Typography sx={fontSx} className={" text-gray-600"}>
            Display Name:{" "}
          </Typography>
        </Grid>

        <Grid size={7}>
          <Typography sx={fontSx}>{displayName}</Typography>
        </Grid>

        <Grid size={{ xs: 6, md: 5 }}>
          <Typography sx={fontSx} className={" text-gray-600"}>
            Firmware Version:{" "}
          </Typography>
        </Grid>
        <Grid size={{ xs: 6, md: 7 }}>
          <Typography sx={fontSx}>{firmwareVersion}</Typography>
        </Grid>

        <Grid size={{ xs: 6, md: 5 }}>
          <Typography sx={fontSx} className={" text-gray-600"}>
            Algorithm Version:{" "}
          </Typography>
        </Grid>
        <Grid size={{ xs: 6, md: 7 }}>
          <Typography sx={fontSx}>{algVersion}</Typography>
        </Grid>
        <Grid size={5}>
          <Typography sx={fontSx} className={" text-gray-600"}>
            Connected Wifi:{" "}
          </Typography>
        </Grid>

        <Grid size={7}>
          {!!wifiName ? (
            <Typography sx={fontSx} display={"inline"}>
              {wifiName}
            </Typography>
          ) : (
            <CircularProgress
              sx={{
                width: [
                  "20px !important",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                ],
                height: [
                  "20px !important",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                ],
                padding: [
                  "0px !important",
                  "8px",
                  "8px",
                  "8px",
                  "8px",
                  "8px",
                  "8px",
                ],
              }}
              className={"p-2"}
            />
          )}
        </Grid>
        <Grid size={5}>
          <Typography sx={fontSx} className={" text-gray-600"}>
            Serial Number:{" "}
          </Typography>
        </Grid>
        <Grid size={7}>
          {hardwareId ? (
            <Typography sx={fontSx}>{hardwareId}</Typography>
          ) : (
            <CircularProgress
              sx={{
                width: [
                  "20px !important",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                ],
                height: [
                  "20px !important",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                ],
                padding: [
                  "0px !important",
                  "8px",
                  "8px",
                  "8px",
                  "8px",
                  "8px",
                  "8px",
                ],
              }}
              className={"p-2"}
            />
          )}
        </Grid>
        <Grid size={5}>
          <Typography sx={fontSx} className={" text-gray-600"}>
            Eth Mac Address:{" "}
          </Typography>
        </Grid>

        <Grid size={7}>
          {ethMac ? (
            <Typography sx={fontSx}>{ethMac}</Typography>
          ) : (
            <CircularProgress
              sx={{
                width: [
                  "20px !important",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                ],
                height: [
                  "20px !important",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                ],
                padding: [
                  "0px !important",
                  "8px",
                  "8px",
                  "8px",
                  "8px",
                  "8px",
                  "8px",
                ],
              }}
              className={"p-2"}
            />
          )}
        </Grid>
        <Grid size={5}>
          <Typography sx={fontSx} className={" text-gray-600"}>
            Wlan Mac Address:{" "}
          </Typography>
        </Grid>

        <Grid size={7}>
          {wifiMac ? (
            <Typography sx={fontSx}>{wifiMac}</Typography>
          ) : (
            <CircularProgress
              sx={{
                width: [
                  "20px !important",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                ],
                height: [
                  "20px !important",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                  "40px",
                ],
                padding: [
                  "0px !important",
                  "8px",
                  "8px",
                  "8px",
                  "8px",
                  "8px",
                  "8px",
                ],
              }}
              className={"p-2"}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default DeviceDetails;
